import React from 'react';
import { Link } from 'react-router-dom';
import { Divider } from 'antd';
import DokanIcons from '../icon/DokanIcons';
/**
 * @param  {} {cardTitle
 * @param  {} hasButton
 * @param  {} buttonLink
 * @param  {} buttonText
 * @param  {} children
 * @param  {} hasCustomBg
 * @param  {} customBgColor
 * @param  {} disableMargin}
 */
const DokanCard = ({
    hasTitle,
    cardTitle,
    hasButton,
    buttonLink,
    buttonText,
    hasDivider,
    hasSvg,
    svgIcon,
    children,
    disableMargin,
    disableTopPadding,
    icon,
    hasCustomBg,
    customBgColor,
    hasTextColor,
    customTextColor,
}) => (
    <div
        className={`pb-35px rounded-md border border-primary ${
            disableMargin ? 'mt-0px' : 'mt-20px'
        } ${disableTopPadding ? 'pt-0px' : 'pt-35px'} ${hasCustomBg ? customBgColor : 'bg-white'}`}
    >
        <div className="px-25px">
            {hasTitle && (
                <div className="flex justify-between mb-30px">
                    <div>
                        {cardTitle && (
                            <div className="flex">
                                <div>{hasSvg && <DokanIcons icon={svgIcon} />}</div>
                                <div>
                                    <h3 className="text-dark text-md font-bold">{cardTitle}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>{icon && <img src={icon} alt={icon} className="" />}</div>
                    <div>
                        {hasButton && (
                            <button
                                className={`${
                                    hasTextColor ? customTextColor : 'text-dark'
                                } 'text-sm' 'text-bold'`}
                                type="button"
                            >
                                <Link to={buttonLink}>{buttonText}</Link>
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
        {hasDivider && <Divider />}

        <div className="px-25px">{children}</div>
    </div>
);

export default DokanCard;
